module.exports = " <div> <span v-if=showTimeString>{{timeString}}</span> <div class=vux-clocker-tpl><slot></slot></div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/.1.2.3@vue-html-loader!./~/.8.7.0@vue-loader/lib/selector.js?type=template&index=0!./~/.0.1.3@vux/src/components/clocker/index.vue
// module id = 213
// module chunks = 2